/* src/app/home-new/tooltip-info-components/tooltip-info-stapling/tooltip-info-stapling.component.scss */
img {
  max-width: 50px;
}
/*# sourceMappingURL=tooltip-info-stapling.component-T36RTPEA.css.map */
